import React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Typography from '@mui/material/Typography';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';

export default function ChartCard({ title, description, loading, empty, emptyMessage = 'Sem dados para exibir.', action, height = 280, children }) {
    return (
        <Card sx={{ p: 2.5, display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="h5" component="h2">{title}</Typography>
                    {description && (
                        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
                            {description}
                        </Typography>
                    )}
                </Box>
                {action}
            </Box>
            <Box sx={{ position: 'relative', height }}>
                {loading ? (
                    <Skeleton variant="rounded" sx={{ width: '100%', height: '100%' }} />
                ) : empty ? (
                    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 1, color: 'text.secondary', border: '1px dashed', borderColor: 'divider', borderRadius: 2 }}>
                        <BarChartOutlinedIcon sx={{ color: 'text.disabled' }} />
                        <Typography variant="body2" color="text.secondary">{emptyMessage}</Typography>
                    </Box>
                ) : (
                    children
                )}
            </Box>
        </Card>
    );
}
